import React from 'react'

const AboutCustomer = () => {
    return (
        <div>
            <div className="bg-[#F0FDF8] py-10 md:py-16 px-4">
                <div className="container mx-auto max-w-4xl">
                    <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 text-center leading-tight">
                        About Customer
                    </h1>
                </div>
            </div>

            <div className="flex-grow container mx-auto pb-10 md:pb-16 px-4 sm:px-6">
                <div className="bg-white p-5 sm:p-8 md:p-12 max-w-4xl mx-auto">
                    <p>
                        <span style={{ fontWeight: 400 }}>
                            Welcome to Maidly! Maidly, your go-to app for professional home services
                            that bring convenience, comfort, and quality right to your doorstep. We
                            understand how busy life can get, our mission is to make everyday chores
                            and personal care simple, reliable and stress free for you.&nbsp;
                        </span>
                    </p>
                    <p>&nbsp;</p>
                    <p>
                        <span style={{ fontWeight: 400 }}>
                            Founded in 2022 by SK Saif and Dinesh Kumar,{" "}
                        </span>
                        <strong>Maidly</strong>
                        <span style={{ fontWeight: 400 }}>
                            {" "}
                            has grown rapidly from a visionary startup to a national service provider.
                            Today, we offer comprehensive household solutions across every city,
                            ensuring that no matter where you are, professional help is just a tap
                            away. Maidly is dedicated to providing the perfect solution for your
                            household problems with efficiency and care.
                        </span>
                    </p>
                    <p>
                        <span style={{ fontWeight: 400 }}>
                            We’re here to ensure you never have to worry about home maintenance again.
                            In the 21st century, you shouldn't have to waste time searching for
                            reliable maids or plumbers. Whether directly or indirectly related to your
                            household needs,{" "}
                        </span>
                        <strong>Maidly</strong>
                        <span style={{ fontWeight: 400 }}>
                            {" "}
                            is available 24/7 to provide the perfect solution to your home service
                            problems. Sit back and rest—we’ll handle the rest.
                        </span>
                    </p>
                    <p>
                        <span style={{ fontWeight: 400 }}>The idea for </span>
                        <strong>Maidly</strong>
                        <span style={{ fontWeight: 400 }}>
                            {" "}
                            was born during my sister’s wedding. Instead of celebrating, my mother and
                            sisters were stressed, cleaning the house because the hired help never
                            showed up. My mother worked so hard that she ended up missing one of the
                            main functions—exhausted and overwhelmed. That wasn't right. I decided
                            then that no family should have to choose between a clean home and
                            celebrating life’s milestones. I created Maidly to solve that problem with
                            reliability and ease.
                        </span>
                    </p>
                    <p>&nbsp;</p>
                    <p>
                        <span style={{ fontWeight: 400 }}>My mother was the inspiration for </span>
                        <strong>Maidly</strong>
                        <span style={{ fontWeight: 400 }}>
                            , so it was only fitting that she became our very first user. Seeing her
                            smile—knowing she no longer has to stress over household chores—is my
                            greatest motivation. Maidly isn't just about cleaning; it’s a complete
                            solution for everything from plumbing to gardening. We are here to handle
                            every household need so you can focus on what matters most.&nbsp;
                        </span>
                    </p>
                    <p>&nbsp;</p>
                    <p>
                        <strong>Why Maidly Only?</strong>
                    </p>
                    <p>
                        <span style={{ fontWeight: 400 }}>Think of </span>
                        <strong>Maidly Partners</strong>
                        <span style={{ fontWeight: 400 }}>
                            {" "}
                            as your buddies—your best friends who are always ready to help. We
                            prioritize your peace of mind; if you ever face an issue with a service
                            provider, our support team is just a click away. We are here to listen,
                            solve your problems, and ensure you receive the best possible service.
                            It’s professional management with a friendly touch.
                        </span>
                    </p>
                    <p>&nbsp;</p>
                    <p>&nbsp;</p>
                    <ul>
                        <li>
                            <strong>
                                <strong>On Time&nbsp;</strong>
                            </strong>
                        </li>
                    </ul>
                    <p>&nbsp;</p>
                    <p>
                        <span style={{ fontWeight: 400 }}>
                            At Maidly, we know your time is valuable. Punctuality is our priority
                            because delays aren't just inconvenient—they’re unacceptable. Our partners
                            are committed to arriving on time, every time. In the rare event of a
                            delay, please notify us immediately. We take direct action to resolve the
                            issue and provide fair compensation, ensuring Maidly remains your most
                            reliable service provider.
                        </span>
                    </p>
                    <p>&nbsp;</p>
                    <p>&nbsp;</p>
                    <ul>
                        <li>
                            <strong>
                                <strong>24*7 Availability</strong>
                            </strong>
                        </li>
                    </ul>
                    <p>&nbsp;</p>
                    <p>
                        <span style={{ fontWeight: 400 }}>
                            Your schedule is our priority. Whether it’s an early morning cleaning or a
                            midnight plumbing emergency, Maidly is available 24/7. We provide top-tier
                            household services that fit your timeline and your wallet. Get the best
                            results with our budget-friendly home solutions, available whenever you
                            need them.
                        </span>
                    </p>
                    <p>&nbsp;</p>
                    <p>&nbsp;</p>
                    <ul>
                        <li>
                            <strong>
                                <strong>Hygiene</strong>
                            </strong>
                        </li>
                    </ul>
                    <p>&nbsp;</p>
                    <p>
                        <span style={{ fontWeight: 400 }}>
                            Looking for hygienic home cleaning services? Maidly ensures all service
                            providers follow rigorous safety and sanitization protocols. We know how
                            critical an unhygienic environment can be for your health, so our workers
                            are committed to maintaining maximum cleanliness at every job. Choose the
                            best-rated hygienic household services, today.
                        </span>
                    </p>
                    <p>&nbsp;</p>
                    <p>&nbsp;</p>
                    <ul>
                        <li>
                            <strong>
                                <strong>Easy &amp; Fast Booking</strong>
                            </strong>
                        </li>
                    </ul>
                    <p>&nbsp;</p>
                    <p>
                        <span style={{ fontWeight: 400 }}>
                            Searching for an easy-to-use app for home cleaning? Maidly allows you to
                            instantly book a maid who fits your exact needs. Whether you need a quick
                            clean or a specific service, our platform offers total flexibility and
                            speed. Enjoy customizable household services with efficiency and
                            affordability. Experience the fastness and reliability of Maidly today.
                        </span>
                    </p>
                    <p>&nbsp;</p>
                    <p>&nbsp;</p>
                    <ul>
                        <li>
                            <strong>
                                <strong>Verified &amp; Trusted Maids</strong>
                            </strong>
                        </li>
                    </ul>
                    <p>&nbsp;</p>
                    <p>
                        <span style={{ fontWeight: 400 }}>
                            Your safety is our top priority. Every Maidly partner undergoes a rigorous
                            background check and a multi-step verification process before joining our
                            platform. We don't just send a worker; we send a Verified &amp; Trusted
                            Professional you can feel comfortable welcoming into your home. With
                            Maidly, you get peace of mind along with premium service.
                        </span>
                    </p>
                    <p>
                        <br />
                        <br />
                    </p>
                    <p>
                        <strong>Our Mission&nbsp;</strong>
                    </p>
                    <p>
                        <span style={{ fontWeight: 400 }}>
                            Maidly’s mission is to become the nation’s most{" "}
                        </span>
                        <strong>reliable household service provider</strong>
                        <span style={{ fontWeight: 400 }}>
                            . We aim to make modern living more comfortable by offering{" "}
                        </span>
                        <strong>background-verified maids, plumbers, and technicians</strong>
                        <span style={{ fontWeight: 400 }}>
                            . By combining 24/7 availability with{" "}
                        </span>
                        <strong>trusted professional help</strong>
                        <span style={{ fontWeight: 400 }}>
                            , our goal is to provide every home with a seamless, safe, and
                            budget-friendly solution for all domestic needs.
                        </span>
                    </p>
                    <p>&nbsp;</p>
                    <p>
                        <strong>Our Vision&nbsp;</strong>
                    </p>
                    <p>
                        <span style={{ fontWeight: 400 }}>Maidly envisions becoming the </span>
                        <strong>leading nationwide platform for on-demand home solutions</strong>
                        <span style={{ fontWeight: 400 }}>
                            . Our goal is to revolutionize the industry by setting new benchmarks for{" "}
                        </span>
                        <strong>safety, reliability, and professional hygiene</strong>
                        <span style={{ fontWeight: 400 }}>
                            . We are committed to scaling our technology to ensure that every city has
                            access to{" "}
                        </span>
                        <strong>verified household professionals</strong>
                        <span style={{ fontWeight: 400 }}>
                            , making 'Maidly' synonymous with home comfort and trust.
                        </span>
                    </p>
                    <p>&nbsp;</p>
                    <p>
                        <strong>Our Values</strong>
                    </p>
                    <p>
                        <span style={{ fontWeight: 400 }}>At </span>
                        <strong>Maidly</strong>
                        <span style={{ fontWeight: 400 }}>
                            , our mission is to simplify your daily life—whether at home, in the
                            office, or anywhere in between. We are committed to providing
                            high-quality, budget-friendly services that save you both time and money.
                            As we expand across India, our goal is to ensure that no matter where you
                            live, our dedicated team is always ready to serve you with
                            excellence.&nbsp;
                        </span>
                    </p>
                    <p>
                        <br />
                        <br />
                    </p>
                    <p>
                        <strong>Services&nbsp;</strong>
                    </p>
                    <ul>
                        <li style={{ fontWeight: 400 }}>
                            <span style={{ fontWeight: 400 }}>Household</span>
                        </li>
                        <li style={{ fontWeight: 400 }}>
                            <span style={{ fontWeight: 400 }}>Plumbers&nbsp;</span>
                        </li>
                        <li style={{ fontWeight: 400 }}>
                            <span style={{ fontWeight: 400 }}>Cleaning&nbsp;</span>
                        </li>
                        <li style={{ fontWeight: 400 }}>
                            <span style={{ fontWeight: 400 }}>Gardaning&nbsp;&nbsp;</span>
                        </li>
                        <li style={{ fontWeight: 400 }}>
                            <span style={{ fontWeight: 400 }}>Repair</span>
                        </li>
                        <li style={{ fontWeight: 400 }}>
                            <span style={{ fontWeight: 400 }}>Technical</span>
                        </li>
                        <li style={{ fontWeight: 400 }}>
                            <span style={{ fontWeight: 400 }}>Cook</span>
                        </li>
                        <li style={{ fontWeight: 400 }}>
                            <span style={{ fontWeight: 400 }}>Personal Care&nbsp;</span>
                        </li>
                        <li style={{ fontWeight: 400 }}>
                            <span style={{ fontWeight: 400 }}>On Demand&nbsp;</span>
                        </li>
                    </ul>
                    <p>&nbsp;</p>
                    <p>
                        <span style={{ fontWeight: 400 }}>
                            At Maidly, we treat your household problems as our own. Our mission is to
                            provide seamless household solutions that take the stress out of your day.
                            By offering on-demand home services, we ensure that professional help is
                            always available when you need it most. Let us handle the hard work so you
                            can enjoy a simpler, easier life.&nbsp;
                        </span>
                    </p>
                    <p>&nbsp;</p>
                    <p>
                        <strong>Our Achievements&nbsp;</strong>
                    </p>
                    <p>
                        <span style={{ fontWeight: 400 }}>
                            Maidly is proud of its journey as a{" "}
                        </span>
                        <strong>top-rated home service app</strong>
                        <span style={{ fontWeight: 400 }}>. Our key achievements include:</span>
                    </p>
                    <ul>
                        <li style={{ fontWeight: 400 }}>
                            <strong>Nationwide Coverage:</strong>
                            <span style={{ fontWeight: 400 }}>
                                {" "}
                                Successfully expanding our household solutions to every major city.
                            </span>
                        </li>
                        <li style={{ fontWeight: 400 }}>
                            <strong>Rapid Growth:</strong>
                            <span style={{ fontWeight: 400 }}>
                                {" "}
                                Scaling from a startup in 2022 to a trusted national brand.
                            </span>
                        </li>
                        <li style={{ fontWeight: 400 }}>
                            <strong>Unmatched Reliability:</strong>
                            <span style={{ fontWeight: 400 }}>
                                {" "}
                                Achieving a 99% punctuality rate among our verified partners.
                            </span>
                        </li>
                        <li style={{ fontWeight: 400 }}>
                            <strong>Customer Trust:</strong>
                            <span style={{ fontWeight: 400 }}>
                                {" "}
                                Serving thousands of families with budget-friendly and hygienic
                                solutions.
                            </span>
                        </li>
                    </ul>
                    <p>
                        <br />
                        <br />
                    </p>
                </div>
            </div>

        </div>
    )
}

export default AboutCustomer